import { $window, $body } from '../Constants';
import HtmlElement from './HtmlElement';

/**
 * Content Slider
 */
const ContentSlider = (() => {
  // Constants
  const DATA_KEY = 'ig.header';
  const EVENT_KEY = `.${DATA_KEY}`;

  /**
   * Selector
   */
  const Selector = {
    CONTENT_SLIDER: '.content-slider'
  };

  /**
   * ClassName
   */
  const ClassName = {
    NAV_INSIDE: 'nav-inside'
  };

  /**
   * Event
   */
  const Event = {
    RESIZE: `resize${EVENT_KEY}`
  };

  /**
   * ContentSlider
   *
   * @class
   * @augments HtmlElement
   */
  class ContentSlider extends HtmlElement {
    // Public

    /**
     * Handles ready event
     *
     * @return void
     */
    onReady() {
      this._init();
      this._toggleNavInside();
      this._bindHandlers();
    }

    // Private

    /**
     * Binds the event handlers to the elements
     *
     * @return void
     */
    _bindHandlers() {
      $window.on(Event.RESIZE, () => {
        this._toggleNavInside();
      });
    }

    /**
     * Initializes the slider
     *
     * @return void
     */
    _init() {
      this.$element.each((i, el) => {
        let $el = $(el),
            data = $el.data();

        let opts = {
          navText: ['<i class="fas fa-angle-left"></i>', '<i class="fas fa-angle-right"></i>'],
          margin: 30,
          items: 1,
          responsive: {
            600: {
              items: 2
            },
            1000: {
              items: $el.data('owl-items')
            }
          },
	      onInitialized: () => {
            this.$element.addClass('owl-initialized');
          }
        };

        for (let prop in data) {
          if (data.hasOwnProperty(prop)) {
            if (prop.substring(0, 3) === 'owl') {
              let p = prop.replace('owl', '');
              p = this._firstToLowerCase(p);

              if (!(p in opts)) {
                opts[p] = data[prop];
              }
            }
          }
        }

        $el.owlCarousel(opts);
      });
    }

    /**
     * Toggles the inside/outside position of the arrow navigation
     *
     * @return void
     */
    _toggleNavInside() {
      let winW = $window.width();

      if (this.$element.data('nav-inside') === 0) {
        let $row = this.$element.closest('.row'),
            rowMaxW = parseInt($row.css('max-width')),
            arrowLeftMinus = 32,
            arrowRightMinus = 32,
            rowMaxWArrows = rowMaxW + arrowLeftMinus + arrowRightMinus;

        if (!this.$element.hasClass(ClassName.NAV_INSIDE)) {
          if (winW <= rowMaxWArrows) {
            this.$element.addClass(ClassName.NAV_INSIDE);
          }
        } else {
          if (winW > rowMaxWArrows) {
            this.$element.removeClass(ClassName.NAV_INSIDE);
          }
        }
      }
    }

    /**
     * Get string with first letter lowercased
     *
     * @param {string} str string
     * @returns {string}
     */
    _firstToLowerCase(str) {
      return str.substr(0, 1).toLowerCase() + str.substr(1);
    }
  }

  return ContentSlider._getElements(Selector.CONTENT_SLIDER, ContentSlider);
})();

export default ContentSlider;
